/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Duration_TitlecaseInputs */

const en_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const fr_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree`)
};

const de_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const ru_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность`)
};

const es_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const zh_cn2_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_ccsl_export_header_duration_titlecase = /** @type {(inputs: Ccsl_Export_Header_Duration_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Ccsl_Export_Header_Duration_TitlecaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_duration_titlecase = /** @type {((inputs?: Ccsl_Export_Header_Duration_TitlecaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Duration_TitlecaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "de") return de_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "it") return it_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "ru") return ru_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "es") return es_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "ja") return ja_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "hi") return hi_ccsl_export_header_duration_titlecase(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_duration_titlecase(inputs)
	return en_ccsl_export_header_duration_titlecase(inputs)
});